import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Button from '../core/button/CoreButton';
import { MixinAnimationFadeFast } from '../core/structure/DefaultStyles';

export default function SpacedLoader() {
    const { t } = useTranslation();
    return (
        <SplashLoaderWrapper>
            <SpacedProgress />

            <Button
                $color="quick"
                $size="small"
                onClick={() => {
                    window.location.reload();
                }}>
                {t('common:reload')}
            </Button>
        </SplashLoaderWrapper>
    );
}

export const SpacedProgress = styled(CircularProgress)`
    margin: 16px;
`;
const SplashLoaderWrapper = styled.div`
    min-height: 90vh;
    flex: 1;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    ${MixinAnimationFadeFast}
    img {
        height: 128px;
        width: 128px;
    }
`;
